import React, { useEffect, useRef } from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
export function MensHealth() {
  const containerRef = useRef(null);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const handleMouseMove = e => {
      const x = e.clientX / window.innerWidth;
      const y = e.clientY / window.innerHeight;
      container.style.setProperty('--mouse-x', x);
      container.style.setProperty('--mouse-y', y);
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);
  return <div ref={containerRef} className="min-h-screen w-full" style={{
    backgroundImage: 'radial-gradient(circle at calc(var(--mouse-x, 0.5) * 100%) calc(var(--mouse-y, 0.5) * 100%), rgba(200, 90, 21, 0.08), transparent 20%)',
    backgroundSize: '120% 120%',
    backgroundPosition: 'center'
  }} data-id="element-543">
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 overflow-hidden" data-id="element-544">
        {/* Decorative elements */}
        <div className="absolute inset-0 overflow-hidden" data-id="element-545">
          <div className="absolute -top-[30%] -right-[10%] w-[70%] h-[70%] rounded-full bg-gradient-to-br from-[#C85A15]/20 to-transparent blur-3xl" data-id="element-546"></div>
          <div className="absolute -bottom-[30%] -left-[10%] w-[70%] h-[70%] rounded-full bg-gradient-to-tr from-[#BBDDFF]/10 to-transparent blur-3xl" data-id="element-547"></div>
        </div>
        <div className="container mx-auto px-6 relative z-10" data-id="element-548">
          <div className="max-w-4xl mx-auto" data-id="element-549">
            <div className="inline-block mb-6 px-4 py-1 rounded-full bg-gradient-to-r from-[#C85A15]/20 to-[#BBDDFF]/20 backdrop-blur-sm border border-white/10" data-id="element-550">
              <span className="text-sm font-medium bg-gradient-to-r from-[#C85A15] to-[#BBDDFF] bg-clip-text text-transparent" data-id="element-551">
                Hormone Therapy & Mens Health
              </span>
            </div>
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight" data-id="element-552">
              <span className="bg-gradient-to-r from-[#C85A15] to-[#FF8A3D] bg-clip-text text-transparent" data-id="element-553">
                Men's Health (TRT)
              </span>
              <br data-id="element-554" />
              <span className="bg-gradient-to-r from-gray-900 to-gray-700 dark:from-white dark:to-gray-300 bg-clip-text text-transparent" data-id="element-555">
                Optimize Your Performance
              </span>
            </h1>
            <p className="text-xl text-gray-600 dark:text-gray-300 mb-10" data-id="element-556">
              Comprehensive testosterone replacement therapy and men's health
              services delivered with discretion, expertise, and ongoing support
              from specialized physicians.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-557">
              <a href="https://app.joinomu.com/patient/onboarding" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-gradient-to-r from-[#C85A15] to-[#FF8A3D] text-white font-medium py-3 px-8 rounded-full hover:shadow-lg transition-all flex items-center justify-center group" data-id="element-558">
                Pricing
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} data-id="element-559" />
              </a>
              <Link to="/weight-loss" className="w-full sm:w-auto bg-white dark:bg-gray-800 text-gray-900 dark:text-white border border-gray-200 dark:border-gray-700 font-medium py-3 px-8 rounded-full hover:shadow-lg transition-all text-center" data-id="element-560">
                Explore Other Treatments
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Treatment Details */}
      <section className="py-20 relative overflow-hidden" data-id="element-561">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-[#C85A15]/10 blur-3xl" data-id="element-562"></div>
        <div className="container mx-auto px-6 relative z-10" data-id="element-563">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-564">
            <div className="order-2 lg:order-1" data-id="element-565">
              <h2 className="text-3xl font-bold mb-6" data-id="element-566">
                <span className="bg-gradient-to-r from-[#C85A15] to-[#FF8A3D] bg-clip-text text-transparent" data-id="element-567">
                  Comprehensive testosterone therapy
                </span>
              </h2>
              <p className="text-lg text-gray-600 dark:text-gray-300 mb-8" data-id="element-568">
                JoinOmu's men's health program provides a complete approach to
                hormone optimization with personalized treatment plans, ongoing
                monitoring, and convenient care delivery.
              </p>
              <div className="space-y-6 mb-8" data-id="element-569">
                <div className="bg-white dark:bg-gray-800/50 rounded-xl p-6 shadow-md border border-gray-100 dark:border-gray-700/30" data-id="element-570">
                  <h3 className="text-xl font-semibold mb-3 flex items-center" data-id="element-571">
                    <CheckCircle className="text-[#C85A15] mr-3 flex-shrink-0" size={24} data-id="element-572" />
                    Hormone Optimization
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-573">
                    Personalized testosterone replacement therapy based on your
                    lab results and symptoms, with ongoing adjustments for
                    optimal results.
                  </p>
                </div>
                <div className="bg-white dark:bg-gray-800/50 rounded-xl p-6 shadow-md border border-gray-100 dark:border-gray-700/30" data-id="element-574">
                  <h3 className="text-xl font-semibold mb-3 flex items-center" data-id="element-575">
                    <CheckCircle className="text-[#C85A15] mr-3 flex-shrink-0" size={24} data-id="element-576" />
                    Discreet & Convenient Care
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-577">
                    Private consultations and medications delivered directly to
                    your door in discreet packaging for complete
                    confidentiality.
                  </p>
                </div>
                <div className="bg-white dark:bg-gray-800/50 rounded-xl p-6 shadow-md border border-gray-100 dark:border-gray-700/30" data-id="element-578">
                  <h3 className="text-xl font-semibold mb-3 flex items-center" data-id="element-579">
                    <CheckCircle className="text-[#C85A15] mr-3 flex-shrink-0" size={24} data-id="element-580" />
                    Comprehensive Health Monitoring
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-581">
                    Lab testing, dosage tracking, and wearable health metric
                    tracking ensures your treatment is safe and effective, with
                    real-time adjustments from your provider as needed.
                  </p>
                </div>
              </div>
              <a href="https://app.joinomu.com/patient/onboarding" target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-gradient-to-r from-[#C85A15] to-[#FF8A3D] text-white font-medium py-3 px-8 rounded-full hover:shadow-lg transition-all group" data-id="element-582">
                Start Your Treatment Today
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} data-id="element-583" />
              </a>
            </div>
            <div className="order-1 lg:order-2" data-id="element-584">
              <div className="relative" data-id="element-585">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/36bsoUrb4cJHcMKroi7tYP/wave.jpg" alt="Men's Health Treatment - Man surfing a large wave" className="w-full h-auto object-cover rounded-xl mb-8" data-id="element-586" />
                <h3 className="text-3xl font-bold mb-6 bg-gradient-to-r from-[#C85A15] to-[#FF8A3D] bg-clip-text text-transparent" data-id="element-587">
                  Testosterone Replacement Therapy
                </h3>
                <p className="text-lg text-gray-600 dark:text-gray-300 mb-6" data-id="element-588">
                  Our specialized physicians create personalized TRT plans to
                  address symptoms of low testosterone, helping you regain
                  energy, focus, and vitality.
                </p>
                <ul className="space-y-3 mb-8" data-id="element-589">
                  <li className="flex items-start" data-id="element-590">
                    <div className="w-5 h-5 rounded-full bg-[#C85A15]/30 flex items-center justify-center mt-1 mr-3" data-id="element-591">
                      <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-592"></div>
                    </div>
                    <span className="text-gray-700 dark:text-gray-200" data-id="element-593">
                      Improved energy and vitality
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-594">
                    <div className="w-5 h-5 rounded-full bg-[#C85A15]/30 flex items-center justify-center mt-1 mr-3" data-id="element-595">
                      <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-596"></div>
                    </div>
                    <span className="text-gray-700 dark:text-gray-200" data-id="element-597">
                      Enhanced physical performance
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-598">
                    <div className="w-5 h-5 rounded-full bg-[#C85A15]/30 flex items-center justify-center mt-1 mr-3" data-id="element-599">
                      <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-600"></div>
                    </div>
                    <span className="text-gray-700 dark:text-gray-200" data-id="element-601">
                      Increased mental clarity and focus
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Benefits Section */}
      <section className="py-20 bg-gradient-to-b from-white to-[#f8faff] dark:from-[#111827] dark:to-[#0a0e17] relative overflow-hidden" data-id="element-602">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-[#C85A15]/10 blur-3xl" data-id="element-603"></div>
        <div className="container mx-auto px-6 relative z-10" data-id="element-604">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-605">
            <div className="inline-block mb-4 px-4 py-1 rounded-full bg-gradient-to-r from-[#C85A15]/10 to-[#BBDDFF]/10 backdrop-blur-sm border border-white/10" data-id="element-606">
              <span className="text-sm font-medium" data-id="element-607">Benefits</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-608">
              <span className="bg-gradient-to-r from-[#C85A15] to-[#FF8A3D] bg-clip-text text-transparent" data-id="element-609">
                Reclaim your vitality and confidence
              </span>
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300" data-id="element-610">
              Testosterone replacement therapy can address a wide range of
              symptoms and improve your overall quality of life.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-611">
            {/* Benefit 1 */}
            <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg border border-gray-100 dark:border-gray-700/30 hover:shadow-xl transition-all" data-id="element-612">
              <div className="w-16 h-16 rounded-full bg-[#C85A15]/20 flex items-center justify-center mb-6" data-id="element-613">
                <svg className="w-8 h-8 text-[#C85A15]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-614">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-615" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-616">Increased Energy</h3>
              <p className="text-gray-600 dark:text-gray-300" data-id="element-617">
                Combat fatigue and experience renewed energy levels throughout
                your day, allowing you to accomplish more.
              </p>
            </div>
            {/* Benefit 2 */}
            <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg border border-gray-100 dark:border-gray-700/30 hover:shadow-xl transition-all" data-id="element-618">
              <div className="w-16 h-16 rounded-full bg-[#C85A15]/20 flex items-center justify-center mb-6" data-id="element-619">
                <svg className="w-8 h-8 text-[#C85A15]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-620">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" data-id="element-621" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-622">Improved Focus</h3>
              <p className="text-gray-600 dark:text-gray-300" data-id="element-623">
                Experience enhanced mental clarity, concentration, and cognitive
                function in both work and daily life.
              </p>
            </div>
            {/* Benefit 3 */}
            <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg border border-gray-100 dark:border-gray-700/30 hover:shadow-xl transition-all" data-id="element-624">
              <div className="w-16 h-16 rounded-full bg-[#C85A15]/20 flex items-center justify-center mb-6" data-id="element-625">
                <svg className="w-8 h-8 text-[#C85A15]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-626">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" data-id="element-627" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-628">Enhanced Libido</h3>
              <p className="text-gray-600 dark:text-gray-300" data-id="element-629">
                Restore sexual health and confidence with improved libido and
                performance for a more satisfying intimate life.
              </p>
            </div>
            {/* Benefit 4 */}
            <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg border border-gray-100 dark:border-gray-700/30 hover:shadow-xl transition-all" data-id="element-630">
              <div className="w-16 h-16 rounded-full bg-[#C85A15]/20 flex items-center justify-center mb-6" data-id="element-631">
                <svg className="w-8 h-8 text-[#C85A15]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-632">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-633" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-634">
                Better Body Composition
              </h3>
              <p className="text-gray-600 dark:text-gray-300" data-id="element-635">
                Support muscle growth and reduce body fat for an improved
                physique and overall physical performance.
              </p>
            </div>
            {/* Benefit 5 */}
            <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg border border-gray-100 dark:border-gray-700/30 hover:shadow-xl transition-all" data-id="element-636">
              <div className="w-16 h-16 rounded-full bg-[#C85A15]/20 flex items-center justify-center mb-6" data-id="element-637">
                <svg className="w-8 h-8 text-[#C85A15]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-638">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-639" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-640">Improved Mood</h3>
              <p className="text-gray-600 dark:text-gray-300" data-id="element-641">
                Experience reduced irritability, anxiety, and depression,
                leading to a more positive outlook and better relationships.
              </p>
            </div>
            {/* Benefit 6 */}
            <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg border border-gray-100 dark:border-gray-700/30 hover:shadow-xl transition-all" data-id="element-642">
              <div className="w-16 h-16 rounded-full bg-[#C85A15]/20 flex items-center justify-center mb-6" data-id="element-643">
                <svg className="w-8 h-8 text-[#C85A15]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-644">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" data-id="element-645" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-646">Better Sleep</h3>
              <p className="text-gray-600 dark:text-gray-300" data-id="element-647">
                Optimize your sleep quality and patterns for improved recovery,
                cognitive function, and overall health.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-20 relative overflow-hidden" data-id="element-648">
        <div className="absolute inset-0 bg-gradient-to-r from-[#C85A15]/30 to-[#FF8A3D]/30 dark:from-[#C85A15]/10 dark:to-[#FF8A3D]/10" data-id="element-649"></div>
        <div className="container mx-auto px-6 relative z-10" data-id="element-650">
          <div className="max-w-4xl mx-auto text-center" data-id="element-651">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-652">
              <span className="bg-gradient-to-r from-[#C85A15] to-[#FF8A3D] bg-clip-text text-transparent" data-id="element-653">
                Ready to optimize your health?
              </span>
            </h2>

            <a href="https://app.joinomu.com/patient/onboarding" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-r from-[#C85A15] to-[#FF8A3D] text-white font-medium py-3 px-10 rounded-full hover:shadow-lg transition-all text-lg" data-id="element-654">
              Verify eligibility
            </a>
          </div>
        </div>
      </section>
    </div>;
}